import images from './images';

const process = [
  {
    id: 1,
    title: 'Consultation',
    content:'We begin with an in-depth consultation to understand your vision, preferences, and the overall theme for your big day.',
    image: images.step1,
    alt: 'Consultation',
  },
  {
    id: 2,
    title: 'Planning',
    content: 'Our experts craft a personalized plan, covering every detail from venue selection to décor, catering, and entertainment.',
    image: images.step2,
    alt: 'Planning',
  },
  {
    id: 3,
    title: 'Design',
    content: 'We design every element to match your dream wedding, from color palettes to floral arrangements and table settings.',
    image: images.step3,
    alt: 'Design',
  },
  {
    id: 4,
    title: 'Coordination',
    content: 'On the day of the wedding, we coordinate with vendors, manage timelines, and ensure that everything runs smoothly.',
    image: images.step4,
    alt: 'Coordination',
  },
  {
    id: 5,
    title: 'Execution',
    content: 'Our team meticulously handles every aspect of the wedding day to ensure flawless execution and a seamless experience.',
    image: images.step5,
    alt: 'Execution',
  },
  {
    id: 6,
    title: 'Post-Wedding Support',
    content: 'We offer post-wedding support, including gift management and any additional services you may require after your big day.',
    image: images.step6,
    alt: 'Post-Wedding Support',
  },
];

export default process;